import React from 'react';
import { Box, Tag, Text } from '@wix/design-system';
import { categoryClick } from '@wix/bi-logger-market/v2';
import { useTranslation } from '../../../../contexts/translations-context';
import { useEssentials, useJunkYard } from '../../../../contexts';
import { Path } from '../../../../models/junk-yard';
import { AppPropertiesDataHooks } from './data-hooks';

export interface AppCollectionsProps {
  appId: string;
  collections: {
    slug: string;
    name: string;
  }[];
}

export const AppCollections = ({ appId, collections }: AppCollectionsProps) => {
  const { t } = useTranslation();
  const { goto } = useJunkYard();
  const { biLogger } = useEssentials();

  return (
    <Box
      dataHook={AppPropertiesDataHooks.featuredInContainer}
      direction="vertical"
      gap="6px"
    >
      <Text size="small" weight="bold">
        {t('solution.page.tagsBoxTitle')}
      </Text>
      <Box gap="6px" flexWrap="wrap">
        {collections.map((collection, index) => {
          return (
            <Tag
              dataHook={`${AppPropertiesDataHooks.appCollection}-${index}`}
              key={collection.slug}
              id={collection.slug}
              removable={false}
              size="tiny"
              onClick={() => {
                biLogger.report(
                  categoryClick({
                    app_id: appId,
                    tag_name: collection.name,
                    tag_type: 'collection',
                    origin: 'more_apps_like_this',
                  }),
                );
                goto({
                  path: Path.COLLECTION,
                  slug: collection.slug,
                  referral: 'app_tag',
                });
              }}
            >
              {collection.name}
            </Tag>
          );
        })}
      </Box>
    </Box>
  );
};
